module.exports = __webpack_public_path__ + "img/Medal@2x.23c185d5.png";